<div
  class="filter-container overflow-x-hidden"
  [ngClass]="{ filterHeight: dataSource?.length <= 10 }"
>
  <!-- <div class="search-filter"><input type="text" placeholder="{{'LEADS.Search' | translate}}"></div> -->
  <div class="filter-scroll-area">
    @if (savedFilter.length > 0) {
      <div class="saved-filter">
        @if (savedFilter?.deal_type?.length) {
          <span class="d-flex flex-wrap">
            @for (
              sfilter of savedFilter?.deal_type;
              track sfilter;
              let i = $index
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">
                  {{
                    getTranslatedText('QUOTE_TEMPLATE.' + sfilter?.name) ||
                      sfilter?.name
                  }}
                </a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(sfilter?.id, 'deal_type')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }

        @if (savedFilter?.actions?.length) {
          <span class="d-flex flex-wrap">
            @for (
              sfilter of savedFilter?.actions;
              track sfilter;
              let i = $index
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">
                  {{
                    getTranslatedText('QUOTE_TEMPLATE.' + sfilter?.name) ||
                      sfilter?.name
                  }}
                </a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(sfilter?.id, 'actions')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }
        @if (savedFilter?.action?.length) {
          <span class="d-flex flex-wrap">
            @for (
              sfilter of savedFilter?.action;
              track sfilter;
              let i = $index
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">
                  {{
                    getTranslatedText('QUOTE_TEMPLATE.' + sfilter?.name) ||
                      sfilter?.name
                  }}
                </a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(sfilter?.id, 'action')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }
        @if (savedFilter?.organization?.length) {
          <span class="d-flex flex-wrap">
            @for (
              sfilter of savedFilter?.organization;
              track sfilter;
              let i = $index
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">
                  {{
                    getTranslatedText('QUOTE_TEMPLATE.' + sfilter?.name) ||
                      sfilter?.name
                  }}
                </a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(sfilter?.id, 'organization')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }

        @if (savedFilter?.contact?.length) {
          <span class="d-flex flex-wrap">
            @for (
              sfilter of savedFilter?.contact;
              track sfilter;
              let i = $index
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">
                  {{
                    getTranslatedText(
                      'QUOTE_TEMPLATE.' +
                        sfilter?.first_name +
                        ' ' +
                        sfilter?.last_name
                    ) || sfilter?.first_name + ' ' + sfilter?.last_name
                  }}
                </a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(sfilter?.id, 'contact')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }
        @if (savedFilter?.member?.length) {
          <span class="d-flex flex-wrap">
            @for (
              sfilter of savedFilter?.member;
              track sfilter;
              let i = $index
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">
                  {{
                    getTranslatedText(
                      'QUOTE_TEMPLATE.' +
                        sfilter?.first_name +
                        ' ' +
                        sfilter?.last_name
                    ) || sfilter?.first_name + ' ' + sfilter?.last_name
                  }}
                </a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(sfilter?.id, 'member')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }

        @if (savedFilter?.status?.length) {
          <span class="d-flex flex-wrap">
            @for (
              sfilter of savedFilter?.status;
              track sfilter;
              let i = $index
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">
                  {{
                    getTranslatedText('QUOTE_TEMPLATE.' + sfilter?.name) ||
                      sfilter?.name
                  }}
                </a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(sfilter?.id, 'status')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }

        @if (savedFilter?.deal_stage?.length) {
          <span class="d-flex flex-wrap">
            @for (
              sfilter of savedFilter?.deal_stage;
              track sfilter;
              let i = $index
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">
                  {{
                    getTranslatedText('QUOTE_TEMPLATE.' + sfilter?.name) ||
                      sfilter?.name
                  }}
                </a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(sfilter?.id, 'deal_stage')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }
        @if (savedFilter?.customFields) {
          <span class="d-flex flex-wrap">
            @for (
              sfilter of savedFilter?.customFields;
              track sfilter;
              let i = $index
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">
                  {{
                    getTranslatedText('QUOTE_TEMPLATE.' + sfilter?.name) ||
                      sfilter?.name
                  }}
                </a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(sfilter?.id, 'customFields')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }

        @if (savedFilter) {
          <span class="d-flex flex-wrap">
            @if (savedFilter?.singale_value) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">{{
                  getTranslatedText(
                    'QUOTE_TEMPLATE.' + savedFilter?.singale_value
                  ) || savedFilter?.singale_value
                }}</a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    class="!h-[18px]"
                    (click)="
                      removeFilter(savedFilter?.singale_value, 'singale_value')
                    "
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
            @if (savedFilter?.total_amount) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">{{
                  getTranslatedText(
                    'QUOTE_TEMPLATE.' + savedFilter?.total_amount
                  ) || savedFilter?.total_amount
                }}</a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="
                      removeFilter(savedFilter?.total_amount, 'total_amount')
                    "
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
            @if (
              savedFilter?.slider_value && savedFilter?.slider_value != '0-0'
            ) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">{{ savedFilter?.slider_value }}</a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="
                      removeFilter(savedFilter?.slider_value, 'slider_value')
                    "
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }

            @if (savedFilter?.singale_date) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">{{
                  savedFilter?.singale_date | customDate
                }}</a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="
                      removeFilter(savedFilter?.singale_date, 'singale_date')
                    "
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
            @if (savedFilter?.due_date) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">{{
                  savedFilter?.due_date | customDate
                }}</a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(savedFilter?.due_date, 'due_date')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
            @if (savedFilter?.from_to_date) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">{{
                  formatDateRange(savedFilter?.from_to_date)
                }}</a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="
                      removeFilter(savedFilter?.from_to_date, 'from_to_date')
                    "
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }

            <!-- <mat-chip class="m-1 filter-input tag-input flex items-center " [selectable]="selectable" *ngIf="savedFilter?.deletedQuotes"
                [removable]="removable">
                <a href="javascript:void(0)">{{savedFilter?.deletedQuotes}}</a>
                <mat-icon matChipRemove class="!h-[18px]" *ngIf="removable"
                    (click)="removeFilter(savedFilter?.deletedQuotes,'deletedQuotes')"> close </mat-icon>
            </mat-chip> -->

            @if (savedFilter?.invoices) {
              <mat-chip
                class="m-1 filter-input tag-input flex items-center"
                [selectable]="selectable"
                [removable]="removable"
              >
                <a href="javascript:void(0)">{{ savedFilter?.invoices }}</a>
                @if (removable) {
                  <mat-icon
                    matChipRemove
                    class="!h-[18px]"
                    (click)="removeFilter(savedFilter?.invoices, 'invoices')"
                  >
                    close
                  </mat-icon>
                }
              </mat-chip>
            }
          </span>
        }
      </div>
    }
    <div class="acordion-filed">
      <mat-accordion>
        @if (type !== 'payment') {
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'COMMON.actions' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="acordion-search">
              <input
                class="acordion-search-input"
                placeholder="{{
                  'QUOTE_TEMPLATE.Search Actions...' | translate
                }}"
                [(ngModel)]="actionSearchTags"
              />
            </div>
            <div class="acordion-input">
              <span class="example-list-section">
                <span>
                  @for (
                    item of activityArr | search: actionSearchTags;
                    track item
                  ) {
                    <p>
                      <mat-checkbox
                        [(ngModel)]="item.checked"
                        (change)="getAccorValue($event, item, 'actions')"
                        >{{
                          getTranslatedText('COMMON.' + item?.name) ||
                            item?.name
                        }}
                      </mat-checkbox>
                    </p>
                  }
                </span>
              </span>
            </div>
          </mat-expansion-panel>
        }
        <!-- <mat-expansion-panel class="py-2" *ngIf="type =='payment'">
                <mat-expansion-panel-header>
                    <mat-panel-title>Action</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="acordion-search">
                    <input class="acordion-search-input" placeholder='{{"QUOTE_TEMPLATE.Search Actions..." | translate}}' [(ngModel)]="actionSearchTags">
                </div>
                <div class="acordion-input">
                    <span class="example-list-section">
                        <span>
                            <p *ngFor="let item of actionListArr | search : actionSearchTags">
                                <mat-checkbox [(ngModel)]="item.checked"
                                    (change)="getAccorValue($event, item, 'action')">{{getTranslatedText ("QUOTE_TEMPLATE." + item?.name ) || item?.name | uppercase}}
                                </mat-checkbox>
                            </p>
                        </span>
                    </span>
                </div>
            </mat-expansion-panel> -->

        @if (type !== 'payment') {
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'QUOTE_TEMPLATE.Quote Stages' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="acordion-search">
              <input
                class="acordion-search-input"
                [placeholder]="'QUOTE_TEMPLATE.Search Quote Stages' | translate"
                [(ngModel)]="statusSearchTags"
              />
            </div>
            <div class="acordion-input">
              <span class="example-list-section">
                <span>
                  @for (
                    item of actionArr | search: statusSearchTags;
                    track item
                  ) {
                    <p>
                      <mat-checkbox
                        [(ngModel)]="item.checked"
                        (change)="getAccorValue($event, item, 'status')"
                      >
                        {{
                          getTranslatedText('QUOTE_TEMPLATE.' + item?.name) ||
                            item?.name
                        }}
                      </mat-checkbox>
                    </p>
                  }
                </span>
              </span>
            </div>
          </mat-expansion-panel>
        }
        @if (type == 'payment') {
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>Status</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="acordion-search">
              <input
                class="acordion-search-input"
                placeholder="Search Status ..."
                [(ngModel)]="statusSearchTags"
              />
            </div>
            <div class="acordion-input">
              <span class="example-list-section">
                <span>
                  @for (
                    item of paymentStatusArr | search: statusSearchTags;
                    track item
                  ) {
                    <p>
                      <mat-checkbox
                        [(ngModel)]="item.checked"
                        (change)="getAccorValue($event, item, 'status')"
                      >
                        {{
                          getTranslatedText('QUOTE_TEMPLATE.' + item?.name) ||
                            item?.name | uppercase
                        }}
                      </mat-checkbox>
                    </p>
                  }
                </span>
              </span>
            </div>
          </mat-expansion-panel>
        }

        <mat-expansion-panel class="py-2">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              'COMMON.organization' | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="acordion-search">
            <input
              class="acordion-search-input"
              [placeholder]="'ORGANIZATION.Search_for_organization' | translate"
              [(ngModel)]="organizationSearchTags"
            />
          </div>
          <div class="acordion-input">
            <span class="example-list-section">
              <span>
                @for (
                  item of allOrgArr | search: organizationSearchTags;
                  track item
                ) {
                  <p>
                    <mat-checkbox
                      [(ngModel)]="item.checked"
                      (change)="getAccorValue($event, item, 'organization')"
                      >{{ item?.name }}
                    </mat-checkbox>
                  </p>
                }
              </span>
            </span>
          </div>
        </mat-expansion-panel>

        @if (type !== 'payment') {
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'COMMON.Users' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="acordion-search">
              <input
                class="acordion-search-input"
                [placeholder]="'ORGANIZATION.SEARCH_MEMBERS' | translate"
                [(ngModel)]="contactSearchTags"
              />
            </div>
            <div class="acordion-input">
              <!-- (scroll)="onScroll($event)" -->
              <span class="example-list-section">
                <span>
                  @for (
                    item of merContactListArr | search: contactSearchTags;
                    track item
                  ) {
                    <p>
                      @if (
                        item?.fname !== null &&
                        item?.fname !== undefined &&
                        item?.fname !== ''
                      ) {
                        <mat-checkbox
                          [(ngModel)]="item.checked"
                          (change)="getAccorValue($event, item, 'contact')"
                          >{{ item?.fname || '' }} {{ item?.lname || '' }}
                        </mat-checkbox>
                      }
                    </p>
                  }
                </span>
              </span>
            </div>
          </mat-expansion-panel>
        }
        @if (type == 'payment') {
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'COMMON.Users' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="acordion-search">
              <input
                class="acordion-search-input"
                [placeholder]="'ORGANIZATION.SEARCH_MEMBERS' | translate"
                [(ngModel)]="contactSearchTags"
              />
            </div>
            <div class="acordion-input">
              <!-- (scroll)="onScroll($event)" -->
              <span class="example-list-section">
                <span>
                  @for (
                    item of merContactListArr | search: contactSearchTags;
                    track item
                  ) {
                    <p>
                      @if (
                        item?.fname !== null &&
                        item?.fname !== undefined &&
                        item?.fname !== ''
                      ) {
                        <mat-checkbox
                          [(ngModel)]="item.checked"
                          (change)="getAccorValue($event, item, 'member')"
                          >{{ item?.fname || '' }} {{ item?.lname || '' }}
                        </mat-checkbox>
                      }
                    </p>
                  }
                </span>
              </span>
            </div>
          </mat-expansion-panel>
        }

        <!-- <mat-expansion-panel class="py-2" *ngIf="type !=='payment'">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ "QUOTE_TEMPLATE.Deleted Quotes"|translate}}</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="acordion-input">
                    <span class="example-list-section">
                        <span>
                            <mat-checkbox [(ngModel)]="deletedQuotes" (change)="wantDeletedQuotes()"
                                >{{ "QUOTE_TEMPLATE.Deleted Quotes"|translate}}
                            </mat-checkbox>
                        </span>
                    </span>
                </div>
            </mat-expansion-panel> -->

        @if (type !== 'payment') {
          <mat-expansion-panel class="py-2">
            <mat-expansion-panel-header>
              <mat-panel-title>{{
                'QUOTE_TEMPLATE.Voided Quotes' | translate
              }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="acordion-input">
              <span class="example-list-section">
                <span>
                  <mat-checkbox
                    [(ngModel)]="voidQuotes"
                    (change)="wantVoidQuotes()"
                    >{{ 'QUOTE_TEMPLATE.Voided Quotes' | translate }}
                  </mat-checkbox>
                </span>
              </span>
            </div>
          </mat-expansion-panel>
        }

        <!-- <mat-expansion-panel class="py-2" *ngIf="type !=='payment'">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ "Void Quotes"|translate}}</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="acordion-input">
                    <span class="example-list-section">
                        <span>
                            <mat-checkbox [(ngModel)]="voidQuotes" (change)="wantVoidQuotes()"
                                >{{ "Void Quotes"|translate}}
                            </mat-checkbox>
                        </span>
                    </span>
                </div>
            </mat-expansion-panel> -->

        <!-- <mat-expansion-panel class="py-2" *ngIf="type !=='payment'">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{"COMMON.Invoice" |translate}}</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="acordion-input">
                    <span class="example-list-section">
                        <span>
                            <mat-checkbox [(ngModel)]="invoices" (change)="quoteInvoice()"
                                >{{"COMMON.Invoice" |translate}}
                            </mat-checkbox>
                        </span>
                    </span>
                </div>
            </mat-expansion-panel> -->
      </mat-accordion>
      @if (type !== 'payment') {
        <div class="check_box">
          <mat-checkbox
            class="content_box mx-3"
            name="rotten days"
            [(ngModel)]="quoteRotten"
            (change)="rottenQuotes()"
            color="primary"
          >
            {{ 'QUOTE_TEMPLATE.rotten_quotes' | translate }}
          </mat-checkbox>
        </div>
      }
      @if (type == 'payment') {
        <div class="value-range-field">
          <div class="value-field">
            <label for="singale_value">{{
              'COMMON.Enter Value' | translate
            }}</label>
            <input
              type="number"
              id="singale_value"
              class="value-input"
              [(value)]="savedFilter.total_amount"
              [formControl]="savedFilter.total_amount"
              (change)="
                getAccorValue($event, singale_value?.value, 'total_amount')
              "
            />
          </div>
          <div class="range-field">
            <label for="range_value">{{
              'COMMON.Select_Range' | translate
            }}</label>
            <div class="range-input" id="range_value" class="range-input">
              <ngx-slider
                [(value)]="sliderValue"
                [(highValue)]="sliderMaxValue"
                [options]="sliderOptions"
                (userChangeEnd)="
                  getAccorValue($event, sliderMaxValue, 'slider_value')
                "
              >
              </ngx-slider>
            </div>
          </div>
        </div>
      }
      @if (type == 'payment') {
        <div class="date-field">
          <div class="single-date-field">
            <label for="single_date">{{
              'COMMON.Enter Date' | translate
            }}</label>
            <app-custom-date
              id="single_date"
              (updateValue)="getAccorValue($event, 'singaledate', 'due_date')"
              dataType="4"
              inputType="date"
              fvalue="{{ savedFilter.due_date }}"
              class="single-date-input"
            >
            </app-custom-date>
          </div>
          <div class="fromto-date-field">
            <div class="from-date-field">
              <label for="start_date">{{ 'COMMON.From' | translate }}</label>
              <app-custom-date
                id="start_date"
                (updateValue)="
                  getAccorValue($event, 'fromtodate', 'start_date')
                "
                dataType="4"
                maxDate="{{ savedFilter.end_date }}"
                inputType="date"
                fvalue="{{ savedFilter.start_date }}"
                class="from-date-input"
              >
              </app-custom-date>
            </div>
            <div class="to-date-field">
              <label for="end_date">{{ 'COMMON.To' | translate }}</label>
              <app-custom-date
                id="end_date"
                (updateValue)="getAccorValue($event, 'fromtodate', 'end_date')"
                dataType="4"
                minDate="{{ savedFilter.start_date }}"
                inputType="date"
                fvalue="{{ savedFilter.end_date }}"
                class="to-date-input"
              >
              </app-custom-date>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="apply-filter-field mt-4 filter-actions">
    <div class="clear-filter-btn">
      <button type="button" (click)="resetFilter()">
        <app-custom-icon icon="round_close"></app-custom-icon>
        {{ 'COMMON.Cancel_Filter' | translate }}
      </button>
    </div>
    <div class="apply-filter-btn">
      <button type="button" (click)="saveFilter()">
        <app-custom-icon icon="round_correct"></app-custom-icon>
        {{ 'COMMON.Apply_Filter' | translate }}
      </button>
    </div>
  </div>
</div>
